// src/components/layouts/admindashboard/header/sub/MobileMenuButton.tsx

import React from "react";

interface MobileMenuButtonProps {
  onClick: () => void;
}

const MobileMenuButton: React.FC<MobileMenuButtonProps> = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="lg:hidden flex items-center justify-center w-10 h-10 rounded-xl bg-black/20 text-white border border-white/30 backdrop-blur-sm hover:bg-accent hover:text-black hover:scale-105 transition-all duration-200 shadow-md"
      aria-label="Menu"
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
      </svg>
    </button>
  );
};

export default MobileMenuButton;  